@if (isLoading | async) {
  <div class="overlay">
    <mat-progress-spinner class="spinner" [diameter]="diameter" [color]="color" [mode]="mode" [value]="value">
    </mat-progress-spinner>
  </div>
}